import '../public/main/config'
import Vue from 'vue';
import App from './App.vue';
import './config/autoLoad';
import router from './config/route';
import $ from 'jquery';
import VueQr from 'vue-qr';
import dataV from '@jiaminghi/data-view'
import Vuetify from 'vuetify'
import 'font-awesome/css/font-awesome.min.css'
import '@mdi/font/css/materialdesignicons.css'
import zhHans from 'vuetify/lib/locale/zh-Hans'
import 'vuetify/dist/vuetify.min.css'
import { VXETable,Button,Icon,Modal} from "vxe-table"
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import XEUtils from 'xe-utils'
import './assets/skin/vuetifytheme.scss'
import '@/assets/default.less';
import '@icon-park/vue/styles/index.css';
import '@genesys/reader/theme/default.css';
// import "./assets/skin/base.less";
// genesysReader.install( Vue );
Vue.config.productionTip = false
window.$ = $;
Vue.use(Vuetify)
Vue.use(VueQr)
Vue.use(dataV)
// VXETable.config({
  
// })
VXETable.setup({
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhCN, key), args),
  zIndex:100
 
})
Vue.use(Button).use(Icon).use(Modal);
window.Vue          =  new Vue({
  router,
  vuetify: new Vuetify({
    lang: {
      locales: {
        zhHans
      },
      current: 'zhHans',
    },
  }),
  render: h => h(App)
}).$mount('#app')


window.$app         = {};
window.$app.router  = router;
window.localUrl     = `${location.protocol}//${location.host}/${window.config.basePath}`
